import ValidateBannerData from "../ValidateBannerData"
import {SupportedRegionTypes} from "../../models/regions"

export const shouldDisplayBackToSiteBanner = (regions, configuration, entrypointHeader, backToNextBannerShowAlways) => {
    const banner = regions?.find(region => region.type === SupportedRegionTypes.BackToSiteBanner)?.elements[0] || null
    const displayBanner =
        configuration.showBanner && (entrypointHeader === configuration.originRealm || backToNextBannerShowAlways)
    return displayBanner && ValidateBannerData(banner)
}
